import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const divider: CSSProperties = {
  marginBottom: spacing.std,
  marginTop: spacing.std,
};

export const title: CSSProperties = {
  marginBottom: spacing.std,
  color: colors.blueDusk.standard,
};

export const stat = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: spacing.lg,
    fontSize: size.md,
  } as CSSProperties,
  label: {
    marginBottom: spacing.xs,
    color: greys.slate,
  },
  value: {
    marginBottom: 5,
  },
};

export const workingHours = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: spacing.std,
    fontSize: size.md,
  } as CSSProperties,
  dayContainer: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: 5,
  } as CSSProperties,
  dayLabel: {
    width: 85,
  },
};
